export { default } from './ImageRotator';
